var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cnav class=\"navbar navbar-default navbar-fixed-top\"\u003E\u003Cdiv class=\"container-fluid\"\u003E\u003Cdiv class=\"navbar-header\"\u003E\u003Cimg" + (pug.attr("src", require("./logo.png"), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collapse navbar-collapse\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/component/menu/header/index.pug
// module id = 275
// module chunks = 0